import * as React from "react";
import useTranslations from "../../hooks/useTranslations";
import useViewer from "../../hooks/useViewer";
import { Badge, ScreenHeader } from "../wombat-ui";
import { DashboardIcon } from '../icons';

const ActivityHeader = () => {
  const t = useTranslations();
  const { company } = useViewer();

  return (
    <ScreenHeader
      title={company.name}
      description={
        <div className="pt-2">
          <Badge variant="secondary">
            {t("activity.metrics.collaborators", { count: company.users.length })}
          </Badge>
        </div>
      }
      icon={DashboardIcon}
    />
  )
};

export default ActivityHeader;
